import { Throttle } from "../00-atoms/00-global/Utils";

export function stickyHeader(): void {
  const threshold = 150;
  const element = document.querySelector(".main-header-container--sticky");

  if (!element) {
    return;
  }

  element.classList.add("show-sticky");
  let previousScrollPos = window.pageYOffset;

  let wait = false;
  const mainNav = document.getElementById("js-main-nav");
  mainNav.addEventListener("mainNavChangeStart", () => {
    wait = true;
  });
  mainNav.addEventListener("mainNavCollaps", () => {
    wait = false;
  });

  function stickyScrollEvent(): void {
    if (wait) return;

    const currentScrollPos = window.pageYOffset;

    if (previousScrollPos < currentScrollPos && currentScrollPos > threshold) {
      if (!element.classList.contains("hide-header")) {
        element.classList.add("hide-header");
        element.classList.remove("show-sticky");
      }
    } else {
      if (!element.classList.contains("show-sticky")) {
        element.classList.remove("hide-header");
        element.classList.add("show-sticky");
      }
    }
    previousScrollPos = window.pageYOffset;
  }

  window.addEventListener(
    "scroll",
    Throttle(() => stickyScrollEvent(), 100),
    { passive: true },
  );
}

document.addEventListener("add-sticky-on-header", () => {
  stickyHeader();
});
